<template>
  <form @submit.prevent="createService" role="form">
    <div class="row no-print">
      <div class="col-12 col-md-4 p-b-15">
        <input v-model="service.name" v-validate="'required'" :class="{ 'error': errors.has('service-name') }"
          name="service-name" type="text" class="form-control pull-right" :placeholder="$t('ServiceHubForm.name_placeholder')">
        <span v-show="errors.has('service-name')" class="error">{{ $t('messages.required_field', { fieldName: $t('ServiceHubTable.name') }) }}</span>
      </div>
      <label for="hub" class="col-1 control-label hub-label">{{ $t("ServiceHubForm.hub") }}</label>
      <div class="col-md-4">
        <multiselect v-model="selectedHub"
                    track-by="id"
                    label="name"
                    :options="hubs"
                    :allow-empty="false"
                    :placeholder="$t('multiselect.placeholder')"
                    :showLabels="false"
                    data-vv-name="hub">
          <span slot="noResult"> {{ $t("multiselect.no_result") }} </span>
        </multiselect>
        <label v-show="errors.has('hub')" id="hub-error" class="error" for="hub">{{ errors.first('hub') }}</label>
      </div>
      <div class="col-6 col-md-2 p-b-15">
        <button type="submit" class="btn btn-secondary btn-block btn-cons" name="create-service">
          <span>{{ $t('actions.add') }}</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ServiceHubForm',
    data: function () {
      return ({
        selectedHub: null,
        service: {
          name: '',
          hub_id: ''
        }
      })
    },
    props: { entityId: Number },
    computed: {
      ...mapGetters({
        hubs: 'hubs/hubList'
      })
    },
    methods: {
      ...mapActions({
        create: 'services/create',
        loadList: 'hubs/loadList',
      }),
      createService() {
        this.$validator.validateAll().then((result) => {
          if(result) {
            this.service.hub_id = this.selectedHub.id
            this.create(this.service)
            .then(data => {
              this.selectedHub = null
              this.service.name = ''
              this.service.hub_id = ''
              this.$validator.reset()
              this.loadList(this.entityId)
            })
          }
        })
      },
      initSelectedHub() {
        this.selectedHub = this.hubs.find(hub => hub.is_fake);
      }
    },
    watch: {
      hubs() {
        this.initSelectedHub();
      }
    },
    mounted() {
      this.initSelectedHub();
    }
  }
</script>

<style lang="scss" scoped>
  .hub-label {
    text-align: center;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/services/ServiceHubForm.vue